'use strict'

const BUBBLE_CLASS = 'hover-tip-bubble'
const GAP = 6

function placeBubble (el, bubble) {

  const rect = el.getBoundingClientRect()
  const bubbleRect = bubble.getBoundingClientRect()
  let top = rect.top - bubbleRect.height - GAP
  let left = rect.left + (rect.width / 2) - (bubbleRect.width / 2)

  if (top < 4) top = rect.bottom + GAP

  const maxLeft = window.innerWidth - bubbleRect.width - 4

  if (left < 4) left = 4
  if (left > maxLeft) left = Math.max(4, maxLeft)

  bubble.style.top = `${Math.round(top)}px`
  bubble.style.left = `${Math.round(left)}px`
}

function hideTip (el) {

  const state = el.__hoverTip

  if (!state || !state.bubble.parentNode) return

  state.bubble.parentNode.removeChild(state.bubble)
  window.removeEventListener('scroll', state.hide, true)
}

function showTip (el) {

  const state = el.__hoverTip
  const text = el.__hoverTipText || ''

  if (!state || !text) return

  state.bubble.textContent = text

  if (!state.bubble.parentNode) document.body.appendChild(state.bubble)

  placeBubble(el, state.bubble)
  window.addEventListener('scroll', state.hide, true)
}

function unbind (el) {

  const state = el.__hoverTip

  if (!state) return

  el.removeEventListener('mouseenter', state.show)
  el.removeEventListener('mouseleave', state.hide)
  el.removeEventListener('mousedown', state.hide)
  el.removeEventListener('focusin', state.show)
  el.removeEventListener('focusout', state.hide)
  el.removeEventListener('keydown', state.onKey)
  hideTip(el)
  delete el.__hoverTip
  delete el.__hoverTipText
}

function bind (el, text) {

  unbind(el)

  if (!text) return

  const bubble = document.createElement('span')

  bubble.className = BUBBLE_CLASS
  bubble.setAttribute('role', 'tooltip')

  const show = () => showTip(el)
  const hide = () => hideTip(el)
  const onKey = (event) => {

    if (event.key === 'Escape') hide()
  }

  el.__hoverTip = { bubble, show, hide, onKey }
  el.__hoverTipText = text
  el.setAttribute('aria-label', text)
  el.addEventListener('mouseenter', show)
  el.addEventListener('mouseleave', hide)
  el.addEventListener('mousedown', hide)
  el.addEventListener('focusin', show)
  el.addEventListener('focusout', hide)
  el.addEventListener('keydown', onKey)
}

const hoverTip = {
  mounted (el, binding) {

    bind(el, binding.value)
  },
  updated (el, binding) {

    const text = binding.value || ''

    if (!text) {

      unbind(el)
      el.removeAttribute('aria-label')
      return
    }

    if (!el.__hoverTip) {

      bind(el, text)
      return
    }

    el.__hoverTipText = text
    el.setAttribute('aria-label', text)

    if (el.__hoverTip.bubble.parentNode) el.__hoverTip.bubble.textContent = text
  },
  unmounted (el) {

    unbind(el)
    el.removeAttribute('aria-label')
  }
}

module.exports = { hoverTip }
